import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { AdultingTamaguiProvider, NetworkStatusProvider } from "../ui-foundation";
import { initWebSentry } from "./lib/sentry";

initWebSentry();

if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js").catch((error) => {
      console.error("Adulting service worker registration failed", error);
    });
  });
}

createRoot(document.getElementById("root")!).render(
  <AdultingTamaguiProvider>
    <NetworkStatusProvider>
      <App />
    </NetworkStatusProvider>
  </AdultingTamaguiProvider>,
);
